import classNames from 'classnames';
import * as React from 'react';

import { useDropZoneInit } from 'ud-form/components/dropzoneV2/hooks/use-drop-zone-init';
import BodyDropzone from 'ud-form/components/dropzoneV2/subcomponents/body-dropzone';
import { Dropzone } from 'ud-form/components/dropzoneV2/subcomponents/dropzone';
import { Format } from 'ud-form/components/dropzoneV2/subcomponents/format';
import Image from 'ud-form/components/dropzoneV2/subcomponents/image';
import { FormDropZoneVariantProps } from 'ud-form/components/dropzoneV2/types';
import { Container } from '../styles';

export const UnionDropzone: React.FC<FormDropZoneVariantProps> = (props) => {
  const { disabled } = props;
  const { images, ...rest } = useDropZoneInit({ name: props.name, disabled });

  const image = (Array.isArray(images) ? images[0] : images) as File | string | undefined;

  const data = React.useMemo(() => {
    if (typeof image === 'string') return { url: image, alt: 'Изображение' };
    if (image instanceof File) return { url: URL.createObjectURL(image), alt: image.name };
    return undefined;
  }, [image]);

  return (
    <Container className={props.className}>
      <Dropzone
        {...rest}
        className={classNames('mb-2 flex flex-row', { disabled })}
        style={{ justifyContent: images.length > 0 ? 'flex-start' : 'center', padding: '20px' }}
      >
        {data && <Image src={data.url} alt={data.alt} />}
        <BodyDropzone
          title={props.title}
          subtitle={props.subtitle}
          buttonText={props.buttonText}
          onButtonClick={props.onButtonClick}
          className="w-full"
        />
      </Dropzone>
      <div className="flex w-full">
        <Format />
      </div>
    </Container>
  );
};
